<template>
  <page name="InducteePage">
    <x-nav slot="header">Inductees</x-nav>
    
    <div class="inducteeList">
      <inductee-item
      v-for="inductee of $root.inductees"
      :inductee="inductee"
      ></inductee-item>
    </div>
    <div slot="footer"></div>
  </page>
</template>

<style>

.ui-li-divider {
  background-image: none !important;
  background-color: #242f3c !important;
  text-align: center !important;
}
</style>

<script>
export default {
  components: {
    'page': require('./Page.vue'),
    'x-nav': require('./Nav.vue'),
    'x-now-playing': require('./NowPlaying.vue'),
    'inductee-item': require('./InducteeItem.vue'),
  },
}
</script>